import React, { useState } from "react";
import Api from "../../config/Api";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (d) => {
    if (d.new_password !== d.confirm_password) {
      toast.error("Invalid Confirm Password", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
    setIsLoading(true);

    const body = {
      current_password: d.current_password,
      new_password: d.new_password,
      new_confirm_password: d.confirm_password,
    };
    const res = await Api("user-change-password", "POST", body);
    // console.log(res);
    if (res?.data?.status === 1) {
      toast.success("Password Changed Successfully!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      reset();
      setIsLoading(false);
    } else {
      if (res.data.message.current_password !== "") {
        toast.error("Invalid Current Password !", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setIsLoading(false);
      } else if (res.data.message.new_password !== "") {
        toast.error("Invalid Current Password !", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="bg-white p-3 rounded p-3 shadow">
        <div className="d-flex justify-content-between mb-3">
          <div className="flex-grow-1">
            <h5 className="text-dark">Change Password</h5>
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              <div className="col-lg-4">
                <label className="form-label">Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Current Password"
                  disabled={isLoading}
                  {...register("current_password", { required: true })}
                  autoComplete="new-password"
                />
                {errors.current_password && (
                  <div className="error_line">Current Password is required</div>
                )}
              </div>

              <div className="col-lg-4">
                <label className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter New Password"
                  disabled={isLoading}
                  {...register("new_password", { required: true })}
                  autoComplete="new-password"
                />
                {errors.new_password && (
                  <div className="error_line">New Password is required</div>
                )}
              </div>

              <div className="col-lg-4">
                <label className="form-label">Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter Confirm Password"
                  disabled={isLoading}
                  {...register("confirm_password", { required: true })}
                  autoComplete="new-password"
                />
                {errors.confirm_password && (
                  <div className="error_line">Confirm Password is required</div>
                )}
              </div>

              <div className="col-lg-3">
                <div>
                  <input
                    type="submit"
                    value="Submit"
                    disabled={isLoading}
                    className="btn btn-primary"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Index;
